import { AppGlobalActions } from '@app/_store/actions/global.actions';
import { Inbox } from '@core/models/interfaces/storage-data/inbox';
import { createFeature, createReducer, on } from '@ngrx/store';

import { InboxActions } from './inbox.actions';

// The impressions already tracked used to live here too, keyed by a session
// id — never written by any reducer, so never read back. They are in
// IndexedDB now (`InboxImpressionsService`), where sign-out ends them.
export type InboxState = Inbox;

export const initialInboxState: InboxState = {
  collection: [],
};

const inboxReducer = createReducer(
  initialInboxState,
  on(AppGlobalActions.loadAppDataSuccess, (state, { globalState }) =>
    // R37. `...(globalState.inbox ?? {})` produced a new state object even
    // when this container was not part of the response, so a one-container
    // load handed all 23 feature slices a new reference and nothing else.
    globalState.inbox ? { ...state, ...globalState.inbox } : state
  ),
  on(InboxActions.loadInboxSuccess, (state, { inbox }) => ({
    ...state,
    ...inbox,
  }))
);

export const inboxFeature = createFeature({
  name: 'inbox',
  reducer: inboxReducer,
  extraSelectors: ({ selectInboxState }) => ({
    selectInboxState,
  }),
});
